// Styles visuels des 4 skins de carte premium (+ défaut basé sur le rang).
export const SKIN_STYLES = {
  skin_neon_paris: {
    name: "Néon Paris",
    c1: "#ff006e", c2: "#00ff88", glow: "rgba(255,0,110,0.55)",
    bg: "linear-gradient(160deg, #0a0a1a 0%, #1a1a3e 100%)",
  },
  skin_or_massif: {
    name: "Or Massif",
    c1: "#ffd700", c2: "#b8860b", glow: "rgba(255,215,0,0.5)",
    bg: "radial-gradient(700px 500px at 30% 15%, #2a2418, transparent 60%), linear-gradient(160deg, #12100a 0%, #000000 100%)",
  },
  skin_street_art: {
    name: "Street Art",
    c1: "#ffd60a", c2: "#ff5c00", glow: "rgba(255,214,10,0.5)",
    bg: "linear-gradient(135deg, #2b2b2b 0%, #171717 100%)",
  },
  skin_galaxie: {
    name: "Galaxie",
    c1: "#c77dff", c2: "#7b2cbf", glow: "rgba(199,125,255,0.55)",
    bg: "radial-gradient(800px 600px at 50% 25%, #2a1a4a, transparent 60%), linear-gradient(160deg, #0a0618 0%, #05030f 100%)",
  },
};
